module.exports = __webpack_public_path__ + "static/img/Logo_ELEM_1_white_short.png";